import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DOM from './header';
import * as userActions from '../../core/user/userActions';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.view = DOM;
    }

    doLogoutRequest = () => {
        const { actions } = this.props;
        actions.logoutRequest();
    }

    render() {
        return this.view();
    }
}

Header.propTypes = {
    actions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...userActions
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
